import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';
import { anchorAttr } from '../../guides/anchors';

/**
 * Strip de cabecera del Portal del cliente: identidad (logo/nombre + color de marca),
 * estado de un vistazo (usuarios con acceso, módulos activos) y acciones primarias
 * (Ver como cliente, Invitar usuario).
 */
export function PortalHeroStrip({ clientId, clientName, brandName, brandColor, logoUrl, usersCount, activeModulesCount, onInvite }) {
    const { t } = useTranslation();
    const accent = brandColor || '#FF470F';
    const title = clientName || brandName || t('portal_modules.hero_untitled');
    // Mostramos la marca visible solo si difiere del nombre del cliente (evita redundancia).
    const showBrand = brandName && brandName !== clientName;

    return (
        <div className="pm-hero" style={{ '--pm-hero-accent': accent }}>
            <div className="pm-hero-identity">
                <div className="pm-hero-logo" style={{ background: logoUrl ? 'transparent' : accent }}>
                    {logoUrl
                        ? <img src={logoUrl} alt="" onError={(e) => { e.target.style.display = 'none'; }} />
                        : <FaIcon iconName="circle-nodes" />}
                </div>
                <div className="pm-hero-text">
                    <span className="pm-hero-eyebrow">{t('portal_modules.hero_eyebrow')}</span>
                    <span className="pm-hero-title">{title}</span>
                    <div className="pm-hero-stats">
                        <span className="pm-hero-stat">
                            <FaIcon iconName="users" />
                            {t('portal_modules.hero_users_count', { count: usersCount })}
                        </span>
                        <span className="pm-hero-stat-dot">·</span>
                        <span className="pm-hero-stat">
                            <FaIcon iconName="grip" />
                            {t('portal_modules.hero_modules_count', { count: activeModulesCount })}
                        </span>
                        {showBrand && (
                            <>
                                <span className="pm-hero-stat-dot">·</span>
                                <span className="pm-hero-stat">
                                    <FaIcon iconName="tag" />
                                    {t('portal_modules.hero_brand_label', { name: brandName })}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className="pm-hero-actions">
                <Link
                    className="btn -negative pm-hero-preview-btn"
                    to={`/client/${clientId}/preview`}
                    target="_blank"
                    {...anchorAttr('portal_preview')}
                >
                    <FaIcon iconName="eye" />
                    {t('portal_tab.preview_portal')}
                </Link>
                <button className="btn -alt" onClick={onInvite} {...anchorAttr('portal_invite')}>
                    <FaIcon iconName="user-plus" />
                    {t('portal_tab.invite_button')}
                </button>
            </div>
        </div>
    );
}
